var styleDataHash = "54643281";
const injectCss = (() => {
  var css = `.Onmgv{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var embed_video_default = {
  "input": "Onmgv"
};
export {
  embed_video_default as default,
  injectCss
};
//# sourceMappingURL=embed-video-scss.js.map
